"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.concatHex = void 0;
function concatHex(...hex) {
    return hex.map((item, index) => (index ? item.slice(2) : item)).join('');
}
exports.concatHex = concatHex;
